import { gql } from 'apollo-angular'

import { ORGANIZATION_FIELDS } from '../../fragments/organization.fragment'

export const UPDATE_ORGANIZATION = gql`
  mutation updateOrganization(
    $id: Int!
    $autosave: Boolean!
    $data: mutationOrganizationUpdateInput!
  ) {
    updateOrganization(id: $id, autosave: $autosave, data: $data) {
      ...OrganizationFields
    }
  }
  ${ORGANIZATION_FIELDS}
`
